import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { ADD_REVIEW, PRODUCT_LIST_REVIEW, REVIEWS, ReviewsFeatureState } from '../reviews-state';

export type ReviewsReducers = ReviewsFeatureState;

export function getReducers(): ActionReducerMap<ReviewsReducers> {
  return {
    reviews: StateUtils.entityLoaderReducer(REVIEWS),
    addReview: StateUtils.loaderReducer(ADD_REVIEW),
    productListReview: StateUtils.loaderReducer(PRODUCT_LIST_REVIEW),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<ReviewsReducers>> = new InjectionToken<
  ActionReducerMap<ReviewsReducers>
>('ReviewsReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
